import { render, staticRenderFns } from "./CoTextbook.vue?vue&type=template&id=0b856522&scoped=true&"
import script from "./CoTextbook.vue?vue&type=script&lang=js&"
export * from "./CoTextbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b856522",
  null
  
)

export default component.exports